import Slider from '../../ui/Slider';
import Table from '../../ui/Table';
import { microtaskTypeData } from '../bounties/microtasktypes/microtaskTypeData';

const QuestionAndAnswerSD = ({ dataTask }) => {
    const titleObject = dataTask?.task.find((obj) => Object.keys(obj).includes('Title'));
    const questionObject = dataTask?.task.find((obj) => Object.keys(obj).includes('heading'));
    const imageObject = dataTask?.task.find((obj) => Object.keys(obj).includes('image'));

    return (
        <Table.Row>
            <p className=" text-textPrimary flex flex-col   ">
                <span className="font-medium mb-1  ">{questionObject?.heading || '-'}</span>
                <span className="text-xs font-medium mb-1"> {titleObject?.Title || '-'} </span>
                {imageObject?.image && <img className="w-[100%] h-32 rounded-md" src={imageObject.image} alt="" />}
            </p>
            <p className="text-sm justify-self-center">
                {microtaskTypeData.find((ele) => ele.type === dataTask.actionType)?.label}
            </p>

            <div>
                <p className=" text-textPrimary mb-1  break-words ">
                    {dataTask?.submission?.answer?.join(' ') ? (
                        dataTask?.submission?.answer?.join(' ')
                    ) : (
                        <span className=" text-textSecondary mb-1 ">Not answered</span>
                    )}
                </p>
            </div>
        </Table.Row>
    );
};

export default QuestionAndAnswerSD;
